module.exports = __webpack_public_path__ + "img/5.7679b733.png";